import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LineItem } from '@contracts/interfaces/lineitem.interface';

@Component({
  selector: 'app-invoice-line-item-find-dialog',
  templateUrl: 'invoice-line-item-find.dialog.html',
  styleUrls: ['./invoice-line-item-find.dialog.scss']
})
export class InvoiceLineItemFindDialogComponent {
  public prefillLineItems: LineItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<InvoiceLineItemFindDialogComponent>

    ) {
      this.prefillLineItems = this.data.prefillLineItems;
    }

    select(item: LineItem) {
      this.dialogRef.close(item);
    }
}
